
import React, { useState, useEffect } from "react";

import { GET_PO_BY_PO_NUMBER, GET_FINANCIAL_YEAR, MODIFY_PO, GET_APPROVED_STAKEHOLDERS } from '../../common/URLs';
import { toast } from 'react-toastify';
import { loaderService } from "../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { Fab, Typography, Container, Card, CardContent, Box, Grid, TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { ConfirmationPopover } from "../../common/commonPopovers/confirmationPopover";
import { handleNumberFieldFocus } from "../../common/commonFunction";
import apiClient from "../../axios";

export function PoModification() {
    const data = useLocation().state?.selectedRow;
    const navigate = useNavigate();
    const [ponumberDetails, setPonumberDetails] = useState();
    const [financialYearList, setFinancialYearList] = useState([]);
    const [urnList, setUrnList] = useState();
    const [poStakeholderType, setPoStakeholderType] = useState(data?.poStakeholderType);
    const [poStakeholderUrn, setPoStakeholderUrn] = useState(data?.poStakeholderUrn);
    const [createPoResponse, setCreatePoResponse] = useState();

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const [updatedDetails, setUpdatedDetails] = useState({
        "poBalanceQuantity": data?.poQuantity,
        "isShortClosedPO": "",
        "shortCloseQuantity": "",
    });

    const [errorMessage, setErrorMessage] = useState({
        "poQuantityError": '',
    });


    useEffect(() => {
        getFinancialYearApi();
    }, []);

    const getFinancialYearApi = () => {
        loaderService.showLoader();
        apiClient.post(GET_FINANCIAL_YEAR,
            null,
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setFinancialYearList(response.data?.financialYearLst);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    useEffect(() => {
        if (poStakeholderType) {
            onStakeholderTypeChange();
        }

    }, [poStakeholderType]);

    const onStakeholderTypeChange = () => {
        loaderService.showLoader();
        apiClient.post(GET_APPROVED_STAKEHOLDERS,
            {
                "type": poStakeholderType
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setUrnList(response.data.stakeHolders);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const handleChange = (e) => {
        // setErrorMessage({ ...errorMessage, [e.target.name]: "" });
        setUpdatedDetails({ ...updatedDetails, [e.target.name]: e.target.value });
        if (e.target.name === "poBalanceQuantity") {
            setUpdatedDetails({ ...updatedDetails, [e.target.name]: e.target.value.slice(0, 10) });
            if (e.target.value <= data?.poBalanceQuantity) {
                setErrorMessage({ ...errorMessage, "poQuantityError": '' })
            } else setErrorMessage({ ...errorMessage, "poQuantityError": "Quantity can not be more than balance Quantity" })
        }

    };

    const onTypeChange = (e) => {
        setPoStakeholderType(e.target.value);
        setErrorMessage({ ...errorMessage, poStakeholderTypeError: "" });
    }

    const onUrnChange = (e) => {
        setPoStakeholderUrn(e.target.value);
        setErrorMessage({ ...errorMessage, poStakeholderUrnError: "" });
    }

    const onConfirmUpdate = (e) => {
        handleConfirmClose();
        modifyPo();
    }

    const onSubmitButtonClick = (e) => {
        handleConfirmOpen();
    }

    const onSubmit = (e) => {
        if (!updatedDetails?.poBalanceQuantity) {
            setErrorMessage({ ...errorMessage, poQuantityError: "Please Enter Quantity" })
        }
        else if (updatedDetails?.poBalanceQuantity > data.poBalanceQuantity) {
            setErrorMessage({ ...errorMessage, poQuantityError: "Quantity can not be more than balance Quantity" })
        }
        else {
            onSubmitButtonClick(e);
        }
    }


    const modifyPo = () => {
        loaderService.showLoader();
        apiClient
            .post(
                MODIFY_PO,
                {
                    "poNumber": data?.poNumber,
                    "poQuantity": data?.poQuantity,
                    "isSentBackForModification": data?.isSentBackForModification === true ? true : data?.isSentBackForModification === false ? false : null,
                    "poBalanceQuantity": updatedDetails?.poBalanceQuantity,
                    "isShortClosedPO": updatedDetails?.poBalanceQuantity === 0 ? true : false,
                    "shortCloseQuantity": updatedDetails?.poBalanceQuantity === 0 ? data?.poQuantity : ''
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                }
            )
            .then((response) => {
                setCreatePoResponse(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log("apiClientERROR", error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };


    useEffect(() => {
        if (createPoResponse) {
            if (createPoResponse.isSuccess === true) {
                toast.success(createPoResponse?.message)
                if (data?.poType === "PO") {
                    navigate('/poList')
                }
                if (data?.poType === "SO") {
                    navigate('/soList')
                }
                if (data?.poType === "STO") {
                    navigate('/stoList')
                }

            }
            else {
                toast.error(createPoResponse?.message ? createPoResponse?.message : "Error")
            }
        }
    }, [createPoResponse]);


    return (
        <>
            <Container maxWidth="xxl">
                {/* {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT66</p>} */}
                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab onClick={() => { navigate(-1) }} size="small" aria-label="back" title='Back'>
                        <KeyboardArrowLeftRounded />
                    </Fab> {data?.poType} Update
                </Typography>
                <Card>
                    <CardContent>
                        <Grid container spacing={1} direction="row" mt={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            type="text"
                                            label="PO Number"
                                            value={data?.poNumber}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.financialYearError}>
                                            <InputLabel>Financial Year</InputLabel>
                                            <Select label="Financial Year" name="financialYear" value={data?.financialYear} disabled onChange={(e) => handleChange(e)}>
                                                {/* <MenuItem value=''>Select</MenuItem> */}
                                                {financialYearList &&
                                                    financialYearList.map((items) => (
                                                        <MenuItem value={items}>{items}</MenuItem>
                                                    ))}
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.financialYearError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.monthError}>
                                            <InputLabel>Month</InputLabel>
                                            <Select required label="Month" name="month" value={data?.month} disabled>
                                                <MenuItem selected>Months</MenuItem>
                                                <MenuItem value="Jan">January</MenuItem>
                                                <MenuItem value="Feb">February</MenuItem>
                                                <MenuItem value="Mar">March</MenuItem>
                                                <MenuItem value="Apr">April</MenuItem>
                                                <MenuItem value="May">May</MenuItem>
                                                <MenuItem value="Jun">June</MenuItem>
                                                <MenuItem value="Jul">July</MenuItem>
                                                <MenuItem value="Aug">August</MenuItem>
                                                <MenuItem value="Sep">September</MenuItem>
                                                <MenuItem value="Oct">October</MenuItem>
                                                <MenuItem value="Nov">November</MenuItem>
                                                <MenuItem value="Dec">December</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.monthError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth required size="small"
                                            error={errorMessage.planningNumberError}
                                            helperText={errorMessage.planningNumberError}
                                            type="text"
                                            name="planningNumber"
                                            label="Planning Number"
                                            value={data?.planningNumber}
                                            disabled

                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.poStakeholderTypeError}>
                                            <InputLabel>Stakeholder Type</InputLabel>
                                            <Select disabled label="Stakeholder Type" name="poStakeholderType" value={data?.poStakeholderType} >
                                                <MenuItem value="Grower">Grower</MenuItem>
                                                <MenuItem value="HIT">HIT</MenuItem>
                                                <MenuItem value="LLE">LLE</MenuItem>
                                                <MenuItem value="Transporter">Transporter</MenuItem>
                                                <MenuItem value="ISO">ISO</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.poStakeholderTypeError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.poStakeholderUrnError}>
                                            <InputLabel>Stakeholder URN</InputLabel>
                                            <Select disabled label="Stakeholder URN" name="poStakeholderUrn" value={data?.poStakeholderUrn} >
                                                {urnList &&
                                                    urnList?.map((items) => (
                                                        <MenuItem value={items.urn}>{items.urn}</MenuItem>

                                                    ))}


                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.poStakeholderUrnError}</FormHelperText>
                                        </FormControl>

                                    </Grid>

                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.poMaterialTypeError}>
                                            <InputLabel>PO Material Type</InputLabel>
                                            <Select disabled label="PO Material Type" name="poMaterialType" value={data?.poMaterialType} >
                                                <MenuItem value="rawbamboo">Raw Bamboo</MenuItem>
                                                <MenuItem value="chipbamboo">Chip Bamboo</MenuItem>
                                                <MenuItem value='Service'>Service</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.poMaterialTypeError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.poTypeError}>
                                            <InputLabel>PO Type</InputLabel>
                                            <Select disabled label="PO Type" name="poType" value={data?.poType} >
                                                <MenuItem value="PO">PO</MenuItem>
                                                <MenuItem value="STO">STO</MenuItem>
                                                <MenuItem value="SO">SO</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.poTypeError}</FormHelperText>
                                        </FormControl>

                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            name="poQuantity"
                                            label="PO Quantity"
                                            value={data?.poQuantity}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"                                          
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            name="poBalanceQuantity"
                                            label="Balance Quantity (MT)"
                                            value={data?.poBalanceQuantity}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth required size="small"
                                            error={errorMessage.poQuantityError}
                                            helperText={errorMessage.poQuantityError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            name="poBalanceQuantity"
                                            label="Update Balance Quantity (MT)"
                                            value={updatedDetails?.poBalanceQuantity}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')' || evt.key === 'e') && evt.preventDefault()}
                                            inputProps={{
                                                maxLength: 10
                                            }}
                                        />
                                    </Grid>


                                    {/* <Grid item xs={12} lg={4}>
                                        <TextField fullWidth required size="small"
                                            error={errorMessage.poDescriptionError}
                                            helperText={errorMessage.poDescriptionError}
                                            type="text"
                                            name="poDescription"
                                            label="PO Description"
                                            value={updatedDetails?.poDescription}
                                            multiline
                                            maxRows={5}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                            inputProps={{
                                                maxLength: 500
                                            }}
                                        />
                                    </Grid> */}
                                    <Grid item xs={12} lg={4} hidden={!data?.landName}>
                                        <TextField fullWidth size="small"
                                            disabled
                                            type="text"
                                            name="landName"
                                            label="Land Name"
                                            value={data?.landName}                  
                                        />
                                    </Grid>
                                    {/* <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            type="text"
                                            name="landId"
                                            label="Land Id"
                                            multiline
                                            value={updatedDetails?.landId}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                            inputProps={{
                                                maxLength: 50
                                            }}
                                        />
                                    </Grid> */}

                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onSubmit(e)}>Submit</Button>
                </Box>
            </Container>
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmUpdate} onClose={handleConfirmClose} action="Submit" />

        </>
    )
}